import { buildWhatsAppLink } from "./translations";

export const LOCALES = { de: "de-DE", ua: "uk-UA", en: "en-GB", pl: "pl-PL", ru: "ru-RU" };
export const WINDOWS = ["08-11", "11-14", "14-17", "17-20"];
export const windowRange = (w) => (w ? w.replace("-", "–") : "");

export const formatDate = (iso, lang) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(LOCALES[lang] || "de-DE", {
    weekday: "short", day: "2-digit", month: "2-digit", year: "numeric",
  });

export const placeOf = (d) => (d.city === "__other" ? d.cityCustom.trim() : d.city);

export const appointmentText = (d, c, lang) => {
  const a = c.appointment;
  const win = d.window ? `${a.windows[d.window]} ${windowRange(d.window)}` : "";
  if (d.mode === "earliest") return a.modes.earliest.title;
  if (d.mode === "flexible") return [a.modes.flexible.title, win].filter(Boolean).join(" · ");
  return [d.date ? formatDate(d.date, lang) : "", win || a.anyTime].filter(Boolean).join(" · ");
};

// Structured WhatsApp text; the customer still has to press Send in WhatsApp.
export const buildBookingWhatsApp = (d, c, lang, { id, photoCount }) => {
  const w = c.wa;
  const lines = [
    w.greeting, "",
    `${w.service}: ${c.services[d.service]?.title || "-"}`,
    `${w.location}: ${placeOf(d)}`,
    `${w.appointment}: ${appointmentText(d, c, lang)}`,
    `${w.name}: ${d.name.trim()}`,
    `${w.phone}: ${d.phone.trim()}`,
  ];
  if (d.email.trim()) lines.push(`${w.email}: ${d.email.trim()}`);
  if (d.item.trim()) lines.push(`${w.object}: ${d.item.trim()}`);
  if (d.notes.trim()) lines.push(`${w.details}: ${d.notes.trim()}`);
  if (photoCount) lines.push(w.photos(photoCount));
  lines.push(`${w.contact}: ${c.details.contacts[d.contact]}`);
  if (id) lines.push("", `${w.ref}: ${id.slice(0, 8).toUpperCase()}`);
  return buildWhatsAppLink(lines.join("\n"));
};
